const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2024 BITPIN. Todos os direitos reservados.</p>
    </footer>
  );
};

export default Footer;
